<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('options.deleteOption')"></page-title>
    </div>

    <jet-form-section @submitted="deleteOption()">

        <template #form>

            <modal-content>

                <div v-if="option.inUse">
                    {{ $t('options.warningInUse')}}
                </div>

                <div v-if="!option.inUse">
                    {{ $t('options.confirmDelete')}}
                </div>

            </modal-content>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    v-if="!option.inUse"
                    :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.delete") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import ModalContent from "@/Shared/Components/ModalContent";
import RadioList from "@/Shared/Components/RadioList";

export default defineComponent({
    props: ["option", "set"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        ModalContent,
        RadioList
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        deleteOption() {
            this.form.delete(this.route("advisors.option.destroy", { optionSet: this.set.uuid, option: this.option.uuid }), {
                preserveScroll: true,
                preserveState: false,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "options.deleted"
                })
            });
        }
    },
    data() {
        return {
            form: useForm({})
        };
    },

});
</script>

<style scoped></style>
